var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _vm.pasoActivoIndex > 1
        ? _c("VolverButton", { on: { click: _vm.handleVolverClick } })
        : _vm._e(),
      _vm._v("  \n  "),
      _vm.isEstadoInactivo || _vm.pasoActivoIndex === _vm.ultimoPasoIndex
        ? _c("GuardarButton", {
            attrs: { disabled: _vm.isNextStepButtonDisabled },
            on: { click: _vm.handleGuardarClick }
          })
        : _c("ContinuarButton", {
            attrs: { disabled: _vm.isNextStepButtonDisabled },
            on: { click: _vm.handleContinuarClick }
          }),
      _vm.confirmarAntesDeGuardar
        ? _c("Confirmation", {
            attrs: {
              show: _vm.showConfirmacionGuardar,
              titulo: _vm.$t("mensajes.crud.crear.titulo", {
                entidad: _vm.entidadTitulo
              }),
              mensaje: _vm.$t("mensajes.crud.crear.mensaje", {
                entidad: _vm.entidadMensaje
              }),
              textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
              textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
            },
            on: { modalConfirmationEmit: _vm.handleConfirmarGuardar }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }